import { useEffect, useState } from "react";
import { X, Download, ExternalLink, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ReceiptViewer({ fileId, title, onClose }) {
  const [url, setUrl] = useState(null);
  const [isPdf, setIsPdf] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let objectUrl = null;
    api.get(`/files/${fileId}`, { responseType: "blob" })
      .then((res) => {
        const type = res.data.type || "";
        setIsPdf(type.includes("pdf"));
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => {
        toast.error("No se pudo cargar el comprobante");
        onClose();
      })
      .finally(() => setLoading(false));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileId]);

  const download = () => {
    if (!url) return;
    const a = document.createElement("a");
    a.href = url;
    a.download = `comprobante_${(title || fileId).replace(/[^a-zA-Z0-9-_ ]/g, "").slice(0, 40)}${isPdf ? ".pdf" : ".jpg"}`;
    a.click();
  };

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center p-4"
      style={{ background: "rgba(5,8,18,0.92)", backdropFilter: "blur(8px)" }}
      onClick={onClose}
      data-testid="receipt-viewer-modal"
    >
      <div className="w-full max-w-3xl panel-strong overflow-hidden flex flex-col" style={{ maxHeight: "92vh" }} onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-3 border-b flex items-center justify-between gap-3" style={{ borderColor: "var(--border)" }}>
          <div className="min-w-0">
            <div className="label-mono">// COMPROBANTE</div>
            {title && <div className="text-sm font-semibold text-slate-100 truncate">{title}</div>}
          </div>
          <div className="flex items-center gap-1.5 shrink-0">
            <button onClick={download} data-testid="receipt-download-btn" className="btn-ghost px-2.5 py-1.5 rounded-sm text-[10px] uppercase tracking-widest flex items-center gap-1.5" style={{ color: "var(--cyan)" }}>
              <Download className="w-3.5 h-3.5" /> Descargar
            </button>
            {url && (
              <a href={url} target="_blank" rel="noreferrer" data-testid="receipt-newtab-btn" className="btn-ghost px-2.5 py-1.5 rounded-sm text-[10px] uppercase tracking-widest flex items-center gap-1.5 text-slate-400">
                <ExternalLink className="w-3.5 h-3.5" /> Pestaña
              </a>
            )}
            <button onClick={onClose} data-testid="receipt-close-btn" className="btn-ghost p-1.5 rounded-sm"><X className="w-4 h-4" /></button>
          </div>
        </div>
        <div className="flex-1 overflow-auto flex items-center justify-center" style={{ background: "#05070f", minHeight: 320 }}>
          {loading ? (
            <Loader2 className="w-8 h-8 animate-spin" style={{ color: "var(--cyan)" }} />
          ) : isPdf ? (
            <iframe title="Comprobante" src={url} className="w-full" style={{ height: "78vh", border: "none" }} />
          ) : (
            <img src={url} alt="Comprobante" className="max-w-full object-contain" style={{ maxHeight: "78vh" }} />
          )}
        </div>
      </div>
    </div>
  );
}
